import { render, staticRenderFns } from "./StartSprint.vue?vue&type=template&id=6aa87dbd&"
import script from "./StartSprint.vue?vue&type=script&lang=js&"
export * from "./StartSprint.vue?vue&type=script&lang=js&"
import style0 from "./StartSprint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports